<template>
    <div>
        <form v-if="!loading" novalidate class="md-layout">
            <md-content class=" md-layout-item md-size-100 md-small-size-100">
                <div class="md-flex-center-center md-form-input">
                    <md-toolbar class="md-toolbar md-table-toolbar md-transparent md-layout md-layout-item md-size-60" md-elevation="0" v-if="isArchive">
                        <div class="md-toolbar-section-start">
                            <h1 class="md-title md-subtitle">
                                {{ $t('views.order.preview.title') }} {{ order.orderType.name || order.orderType }}
                            </h1>
                        </div>
                        <div class="md-toolbar-section-end">
                            <span class="md-subtitle" v-if="!isArchive">{{ $t('views.order.preview.label.status') }} - {{ $t(`views.order.status.${order.status}`) }}</span>

                            <md-button class="md-button md-header-btn md-ml-30" @click="$router.back()">
                                {{ $t('views.order.preview.back') }}
                            </md-button>
                        </div>
                    </md-toolbar>

                    <md-card class="md-form-card md-mt-30 card">
                        <div class="md-layout md-gutter">
                            <div class="md-layout-item md-small-size-100">
                                <md-field>
                                    <label for="campaignName">{{ $t('views.order.preview.label.name') }}</label>
                                    <md-input :value="!isArchive ? campaign && campaign.name : order && order.campaignName" id="campaignName" name="campaignName" :disabled="true" />
                                </md-field>
                            </div>

                            <div class="md-layout-item md-small-size-100">
                                <md-field>
                                    <label for="agency">{{ $t('views.order.preview.label.agency') }}</label>
                                    <md-input :value="!isArchive ? campaign && campaign.agency.name : order && order.agencyName" id="agency" name="agency" :disabled="true" />
                                </md-field>
                            </div>
                        </div>

                        <div class="md-layout md-gutter">
                            <div class="md-layout-item md-small-size-100">
                                <md-field>
                                    <label for="client">{{ $t('views.order.preview.label.client') }}</label>
                                    <md-input :value="!isArchive ? campaign && campaign.client.name : order && order.clientName " id="client" name="client" :disabled="true" />
                                </md-field>
                            </div>

                            <div class="md-layout-item md-small-size-100">
                                <div class="md-layout md-gutter">
                                    <div class="md-layout-item md-small-size-100 md-size-50">
                                        <md-field>
                                            <label>{{ $t('views.order.preview.label.validFrom') }}</label>
                                            <md-input :value="campaign && campaign.validFrom || order && order.validFrom | moment('L')" id="client" name="client" :disabled="true" />
                                        </md-field>
                                    </div>

                                    <div class="md-layout-item md-small-size-100 md-size-50">
                                        <md-field>
                                            <label>{{ $t('views.order.preview.label.validTo') }}</label>
                                            <md-input :value="campaign && campaign.validTo || order && order.validTo | moment('L')" id="client" name="client" :disabled="true" />
                                        </md-field>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="md-layout md-gutter">
                            <div class="md-layout-item md-small-size-100">
                                <md-field>
                                    <label for="spotType">{{ $t('views.order.preview.label.spotType') }}</label>
                                    <md-input :value="order && order.spotType.name || order.spotType" id="spotType" name="spotType" :disabled="true" />
                                </md-field>
                            </div>

                            <div class="md-layout-item md-small-size-100">
                                <md-field>
                                    <label for="packageType">{{ $t('views.order.preview.label.packageType') }}</label>
                                    <md-input :value="order && order.packageType.name || order.packageType" id="packageType" name="packageType" :disabled="true" />
                                </md-field>
                            </div>
                        </div>

                        <div class="md-layout md-gutter">
                            <div :class="isInternetOrRadioOrder ? 'md-layout-item md-small-size-100 md-size-100':'md-layout-item md-small-size-100 md-size-50'">
                                <md-field>
                                    <label for="grpSaleType">{{ $t('views.order.preview.label.grpSaleType') }}</label>
                                    <md-input :value="order && order.grpSaleType.name || order.grpSaleType" id="grpSaleType" name="grpSaleType" :disabled="true" />
                                </md-field>
                            </div>

                            <div class="md-layout-item md-small-size-100 md-size-50" v-if="order && order.targetGroup && !isInternetOrRadioOrder">
                              <md-field>
                                    <label for="targetGroup">{{ $t('views.order.preview.label.targetGroup') }}</label>
                                    <md-input :value="order.targetGroup.name || order.targetGroup" id="targetGroup" name="targetGroup" :disabled="true" />
                                </md-field>
                            </div>
                        </div>
                        <div class="md-layout md-gutter">
                            <div class="md-layout-item md-small-size-50">
                                <md-field v-if="this.hasOrderBudgetNotDefaultValue()">
                                    <label for="priceMethod">{{ $t('views.order.preview.label.priceMethod') }}</label>
                                    <md-input :value="priceMethod()" id="priceMethod" name="priceMethod" :disabled="true" />
                                </md-field>
                            </div>
                            
                            <div class="md-layout-item md-small-size-50 md-size-50">
                                <md-field v-if="this.hasOrderBudgetNotDefaultValue()">
                                    <label for="budget">{{ $t('views.order.preview.label.budget') }}</label>
                                    <md-input :value="order && order.budget" id="budget" name="budget" :disabled="true" />
                                </md-field>
                            </div>
                            <div class="md-layout-item md-small-size-50 md-size-50" v-if="this.hasOrderBudgetNotDefaultValue()">
                                <md-field>
                                    <label for="orderNumber">{{ $t('views.invoice.preview.form.orderNumber') }}</label>
                                    <md-input :value="campaign.orders[0].orderNumber" id="orderNumber" name="orderNumber" :disabled="true" />
                                </md-field>
                            </div>
                            <div class="md-layout-item md-size-50 md-size-50" v-if="!this.hasOrderBudgetNotDefaultValue()">
                                <md-field>
                                    <label for="orderNumber">{{ $t('views.invoice.preview.form.orderNumber') }}</label>
                                    <md-input :value="campaign.orders[0].orderNumber" id="orderNumber" name="orderNumber" :disabled="true" />
                                </md-field>
                            </div>
                            <div class="md-layout-item md-small-size-50 md-size-50">
                                <md-field class="md-small-size-50 md-layout-item" v-if="!isArchive ? order.grp && this.order.orderType.shortName.toLowerCase() != 'internet' && this.order.orderType.shortName.toLowerCase() != 'ooh' : order.grp && this.order.orderType.toLowerCase() != 'internet' && this.order.orderType.toLowerCase() != 'ooh' ">
                                    <label for="grp">{{ $t('views.order.preview.label.grp') }}</label>
                                    <md-input :value="order && order.grp" id="grp" name="grp" :disabled="true" />
                                </md-field>
                                <md-field v-if="!isArchive ? this.order.orderType.shortName.toLowerCase() == 'internet' || this.order.orderType.shortName.toLowerCase() == 'ooh' : this.order.orderType.toLowerCase() == 'internet' || this.order.orderType.toLowerCase() == 'ooh'">
                                    <label for="grp">{{ $t('views.order.preview.label.internet_grp') }}</label>
                                    <md-input :value="order && order.grp" id="grp" name="grp" :disabled="true" />
                                </md-field>
                            </div>
                        </div>
                        <div class="md-layout-item md-small-size-100">
                            <div class="md-layout md-gutter">
                                <div class="md-layout-item md-small-size-100 md-size-50">
                                    <md-field>
                                        <label>{{ $t('views.order.preview.label.confirmDate') }}</label>
                                        <md-input :value="order.confirmDate | moment('L LT')" id="client" name="client" :disabled="true" />
                                    </md-field>
                                </div>
                                <div class="md-layout-item md-small-size-100 md-size-50">
                                    <md-field>
                                        <label>{{ $t('views.order.preview.label.confirmedBy') }}</label>
                                        <md-input :value="order.confirmedBy != null? order.confirmedBy : ''" :disabled="true" />
                                    </md-field>
                                </div>
                            </div>
                        </div>
                        <div class="md-layout-item md-small-size-100 md-size-50" v-if="hasAccess('PRIVILEGE_ORDER_CONFIRM') && isNotConfirmed() && statusDifferentThanCreate() && isNotCreator()">
                            <md-button class="md-button md-header-btn md-ml-60" @click="confirmOrder">
                                {{ $t('views.order.preview.confirm') }} 
                            </md-button>
                        </div>

                        <order-products-table :campaign-id="order.campaignId" :order-id="orderId" v-model="orderProducts"
                                            :allow-edit="false" :draft="true" />

                        <order-product-sequence v-model="orderProductsSequences" :order-products="orderProducts" :order-product-sequences="orderProductsSequences"
                                                :order-id="orderId" :allow-edit="false" :draft="true" class="md-mt-30"
                                                v-if="orderProductsSequences.length > 0" :is-archive="isArchive ? true : false" />

                        <order-stations-table :allow-add-station="false" :campaign-id="order.campaignId" :order-id="orderId"
                                            v-model="orderStations" :allow-edit="false" :draft="true" />

                        <order-attachments-table :allow-add-attachment="false" :campaign-id="order.campaignId" :order-id="orderId" v-model="orderAttachments"
                                            :draft="true" />
                    </md-card>
                </div>
            </md-content>
        </form>
    </div>
</template>

<script>
import serverSideValidationErrors from '@/mixins/serverSideValidationErrors';
import {
    campaignsEndpoint, conditionsEndpoint,
    orderProductsEndpoint,
    ordersEndpoint, orderStationsEndpoint,
    stationsEndpoint, archivesEndpoint, orderAttachmentsEndpoint,
} from '@/services/adsign-backend/endpoints';
import OrderProductsTable from '@/views/order/OrderProductsTable';
import OrderStationsTable from '@/views/order/OrderStationsTable';
import OrderProductSequence from '@/views/order/product/OrderProductSequence';
import OrderAttachmentsTable from '@/views/order/OrderAttachmentsTable'
import { mapGetters } from "vuex";
import auth from '../../store/modules/auth';

export default {
    
    name: 'OrderPreview',
    components: {OrderProductSequence, OrderStationsTable, OrderProductsTable, OrderAttachmentsTable},
    mixins: [serverSideValidationErrors],
    props: {
        orderId: {
            type: [Number, String],
            required: true
        },
        orderProp: {
            type: Object,
            default: undefined
        }
    },
    created(){
        if(!this.isArchive){
            this.order = this.orderProp
        }
    },
    computed: {
        ...mapGetters('order', ["isArchive"]),
        ...mapGetters('auth', ['hasAccess', 'userLogin'])
    },
    data: function () {
        return {
            order: {},
            conditions: [],
            campaign: {},
            orderProducts: [],
            orderStations: [],
            orderProductsSequences: [],
            orderAttachments: [],
            dictionaries: {
                priceMethods: [
                    {
                        name: 'grp',
                        unit: 'GRP'
                    },
                    {
                        name: 'budget',
                        unit: 'PLN'
                    }
                ],
            },
            loading: false
        }
    },
    mounted() {
        if(this.isArchive){
            archivesEndpoint.getOrderDetails(this.orderId).then(result => {
                this.order = {
                    ...result.data,
                    priceMethod: result.data.budget ? 'budget' : 'grp',
                }
                this.orderStations = result.data.stations
                this.orderProducts = result.data.products
                this.orderProductsSequences = result.data.sequences
                })
        }else{
            campaignsEndpoint.getCampaign(this.order.campaignId).then(result => {
                this.campaign = {
                    ...result.data
                };
            });

            orderProductsEndpoint.getOrderProducts(this.orderId).then(result => {
                this.orderProducts = result.data.map(orderProduct => ({
                    ...orderProduct,
                    productName: orderProduct.product.name,
                }));
            });

            orderProductsEndpoint.getOrderProductSequences(this.orderId).then(result => {
                this.orderProductsSequences = result.data.map(seq => ({
                    id: seq.id,
                    data: seq.orderProductIds
                }));
            })

            orderStationsEndpoint.getOrderStations(this.orderId).then(result => {
                this.orderStations = result.data;
            });

            orderAttachmentsEndpoint.getOrderAttachments(this.orderId)
                .then(result => this.orderAttachments = result);
        }
        
    },
    methods: {
        hasOrderBudgetNotDefaultValue(){
            return this.order.budget != 0.1 && this.order.budget != 0.2;
        },
        isOohOrInternetOrder() {
          return this.form.orderType.shortName.toLowerCase() == 'ooh' || this.form.orderType.shortName.toLowerCase() == 'internet';
        },
        isInternetOrder() {
          return this.form.orderType.shortName.toLowerCase() == 'internet';
        },
        isInternetOrRadioOrder() {
          return this.form.orderType.shortName.toLowerCase() == 'radio' || this.form.orderType.shortName.toLowerCase() == 'internet';
        },
        priceMethod() {
                if(this.isArchive){
                  if (this.order.orderType.toLowerCase() == 'internet' || this.order.orderType.toLowerCase() == 'ooh' ) {
                    return this.$t(`views.order.preview.label.internet_${this.order.priceMethod}`);
                    }
                }else{
                if (this.order.orderType.shortName.toLowerCase() == 'internet' || this.order.orderType.shortName.toLowerCase() == 'ooh' ) {
                    return this.$t(`views.order.preview.label.internet_${this.order.priceMethod}`);
                }}
            return this.$t(`views.order.preview.label.${this.order.priceMethod}`);
        },
        confirmOrder() {
            ordersEndpoint.confirmOrder(this.orderId).then((response) => {
                this.order.confirmDate = response.data.confirmDate;
                this.order.confirmedBy = response.data.confirmedBy;
            })    
        },
        isNotConfirmed(){
            return (this.order.confirmDate == null || this.order.confirmDate =='') && this.order.confirmedBy == null || this.order.confirmedBy == '';
        },
        statusDifferentThanCreate(){
            return this.order.status !== 'CREATE';
        },
        isNotCreator(){
            return this.order.createdBy !== this.userLogin;
        }
    }
}
</script>

<style scoped lang="scss">
    .card{
        margin-bottom: 20px;
    }
</style>
